import React from 'react'
import MatchOdds1 from './MatchOdds1'

export const SouthAfrica = () => {
  return (
    <div className="wbb-container">
        <div
          className="wbb-title"
          style={{ backgroundColor: "#441010ff", height: "150px" }}
        ></div>
        <MatchOdds1 />
      </div>
  )
}